// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "0cf71672" + "." + "fc87e96731df586d" + ".js";
};